// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AcceptInvitationData,
  AcceptInvitationErrors,
  AcceptInvitationResponses,
  AcquireLockData,
  AcquireLockErrors,
  AcquireLockResponses,
  ActivateCustomServiceData,
  ActivateCustomServiceErrors,
  ActivateCustomServiceResponses,
  AddShotAssetData,
  AddShotAssetErrors,
  AddShotAssetResponses,
  AnswerInferenceQuestionData,
  AnswerInferenceQuestionErrors,
  AnswerInferenceQuestionResponses,
  ApproveAssetData,
  ApproveAssetErrors,
  ApproveAssetResponses,
  CancelExecutionData,
  CancelExecutionResponses,
  CancelLoraTrainingRunData,
  CancelLoraTrainingRunErrors,
  CancelLoraTrainingRunResponses,
  CancelTimelineExportData,
  CancelTimelineExportErrors,
  CancelTimelineExportResponses,
  ClearCompletedTimelineExportsData,
  ClearCompletedTimelineExportsErrors,
  ClearCompletedTimelineExportsResponses,
  ConfirmAssetUploadData,
  ConfirmAssetUploadErrors,
  ConfirmAssetUploadResponses,
  CreateCredentialData,
  CreateCredentialErrors,
  CreateCredentialResponses,
  CreateCustomServiceData,
  CreateCustomServiceErrors,
  CreateCustomServiceResponses,
  CreateDerivedAssetData,
  CreateDerivedAssetErrors,
  CreateDerivedAssetResponses,
  CreateLoraData,
  CreateLoraErrors,
  CreateLoraResponses,
  CreateProjectData,
  CreateProjectErrors,
  CreateProjectResponses,
  CreateSceneData,
  CreateSceneErrors,
  CreateSceneResponses,
  CreateShotData,
  CreateShotErrors,
  CreateShotResponses,
  CreateSignedCookiesData,
  CreateSignedCookiesErrors,
  CreateSignedCookiesResponses,
  CreateTeamData,
  CreateTeamErrors,
  CreateTeamResponses,
  CreateTimelineData,
  CreateTimelineErrors,
  CreateTimelineExportData,
  CreateTimelineExportErrors,
  CreateTimelineExportResponses,
  CreateTimelineLockData,
  CreateTimelineLockErrors,
  CreateTimelineLockResponses,
  CreateTimelineResponses,
  CreateTimelineVersionData,
  CreateTimelineVersionErrors,
  CreateTimelineVersionResponses,
  CreateWorkflowData,
  CreateWorkflowErrors,
  CreateWorkflowResponses,
  DeclineInvitationData,
  DeclineInvitationErrors,
  DeclineInvitationResponses,
  DeleteAssetData,
  DeleteAssetErrors,
  DeleteAssetResponses,
  DeleteCredentialData,
  DeleteCredentialErrors,
  DeleteCredentialResponses,
  DeleteLoraData,
  DeleteLoraErrors,
  DeleteLoraResponses,
  DeleteNotificationData,
  DeleteNotificationErrors,
  DeleteNotificationResponses,
  DeleteProjectData,
  DeleteProjectErrors,
  DeleteProjectResponses,
  DeleteSceneData,
  DeleteSceneErrors,
  DeleteSceneResponses,
  DeleteShotData,
  DeleteShotErrors,
  DeleteShotResponses,
  DeleteTeamData,
  DeleteTeamErrors,
  DeleteTeamResponses,
  DeleteTimelineExportData,
  DeleteTimelineExportErrors,
  DeleteTimelineExportResponses,
  DeleteTimelineLockData,
  DeleteTimelineLockErrors,
  DeleteTimelineLockResponses,
  DeleteTimelineVersionData,
  DeleteTimelineVersionErrors,
  DeleteTimelineVersionResponses,
  DeleteVersionData,
  DeleteVersionErrors,
  DeleteVersionResponses,
  DeleteWorkflowData,
  DeleteWorkflowErrors,
  DeleteWorkflowResponses,
  DisableCustomServiceData,
  DisableCustomServiceErrors,
  DisableCustomServiceResponses,
  DuplicateWorkflowData,
  DuplicateWorkflowErrors,
  DuplicateWorkflowResponses,
  ExecuteWorkflowData,
  ExecuteWorkflowErrors,
  ExecuteWorkflowResponses,
  GenerateFilmstripData,
  GenerateFilmstripErrors,
  GenerateFilmstripResponses,
  GenerateThumbnailData,
  GenerateThumbnailErrors,
  GenerateThumbnailResponses,
  GenerateVideoChunksData,
  GenerateVideoChunksErrors,
  GenerateVideoChunksResponses,
  GetAssetData,
  GetAssetErrors,
  GetAssetResponses,
  GetCreativeDirectionData,
  GetCreativeDirectionErrors,
  GetCreativeDirectionResponses,
  GetCurrentUserData,
  GetCurrentUserErrors,
  GetCurrentUserResponses,
  GetCustomServiceData,
  GetCustomServiceErrors,
  GetCustomServiceResponses,
  GetExecutionLogsData,
  GetExecutionLogsResponses,
  GetExecutionStatusData,
  GetExecutionStatusResponses,
  GetLoraData,
  GetLoraDatasetPrepData,
  GetLoraDatasetPrepErrors,
  GetLoraDatasetPrepResponses,
  GetLoraErrors,
  GetLoraResponses,
  GetLoraTrainingRunData,
  GetLoraTrainingRunErrors,
  GetLoraTrainingRunResponses,
  GetNodeTypeData,
  GetNodeTypeParametersData,
  GetNodeTypeParametersResponses,
  GetNodeTypeResponses,
  GetNotificationPreferencesData,
  GetNotificationPreferencesErrors,
  GetNotificationPreferencesResponses,
  GetNotificationUnreadCountData,
  GetNotificationUnreadCountErrors,
  GetNotificationUnreadCountResponses,
  GetProjectApplicableEntitlementPoliciesData,
  GetProjectApplicableEntitlementPoliciesErrors,
  GetProjectApplicableEntitlementPoliciesResponses,
  GetProjectData,
  GetProjectErrors,
  GetProjectResponses,
  GetProjectTimelinesData,
  GetProjectTimelinesErrors,
  GetProjectTimelinesResponses,
  GetScenesData,
  GetScenesErrors,
  GetScenesResponses,
  GetSearchFiltersData,
  GetSearchFiltersErrors,
  GetSearchFiltersResponses,
  GetShotAssetsData,
  GetShotAssetsErrors,
  GetShotAssetsResponses,
  GetShotAuditData,
  GetShotAuditErrors,
  GetShotAuditResponses,
  GetShotData,
  GetShotErrors,
  GetShotNodeDetailData,
  GetShotNodeDetailErrors,
  GetShotNodeDetailResponses,
  GetShotNodesData,
  GetShotNodesErrors,
  GetShotNodesResponses,
  GetShotResponses,
  GetTeamData,
  GetTeamErrors,
  GetTeamResponses,
  GetTimelineData,
  GetTimelineErrors,
  GetTimelineExportData,
  GetTimelineExportErrors,
  GetTimelineExportResponses,
  GetTimelineResponses,
  GetTimelineVersionData,
  GetTimelineVersionErrors,
  GetTimelineVersionResponses,
  GetVersionData,
  GetVersionHistoryData,
  GetVersionHistoryResponses,
  GetVersionResponses,
  GetWorkflowData,
  GetWorkflowResponses,
  GetWorkflowTemplatesData,
  GetWorkflowTemplatesErrors,
  GetWorkflowTemplatesResponses,
  GoogleLoginData,
  GoogleLoginErrors,
  GoogleLoginResponses,
  GrantProjectSupportAccessData,
  GrantProjectSupportAccessErrors,
  GrantProjectSupportAccessResponses,
  InitiateAssetUploadData,
  InitiateAssetUploadErrors,
  InitiateAssetUploadResponses,
  InternalExpireLapsedSupportGrantsData,
  InternalExpireLapsedSupportGrantsErrors,
  InternalExpireLapsedSupportGrantsResponses,
  InternalFinalizeTrainingRunData,
  InternalFinalizeTrainingRunErrors,
  InternalFinalizeTrainingRunResponses,
  InternalGetLoraCheckpointData,
  InternalGetLoraCheckpointErrors,
  InternalGetLoraCheckpointResponses,
  InternalGetLoraData,
  InternalGetLoraErrors,
  InternalGetLoraResponses,
  InternalGetTrainingRunData,
  InternalGetTrainingRunErrors,
  InternalGetTrainingRunResponses,
  InternalListNonTerminalTrainingRunsData,
  InternalListNonTerminalTrainingRunsErrors,
  InternalListNonTerminalTrainingRunsResponses,
  InternalRegisterCheckpointData,
  InternalRegisterCheckpointErrors,
  InternalRegisterCheckpointResponses,
  InternalSetTrainingRunExternalJobData,
  InternalSetTrainingRunExternalJobErrors,
  InternalSetTrainingRunExternalJobResponses,
  InternalSetTrainingRunStatusData,
  InternalSetTrainingRunStatusErrors,
  InternalSetTrainingRunStatusResponses,
  ListAssetsData,
  ListAssetsErrors,
  ListAssetsResponses,
  ListBinItemsData,
  ListBinItemsErrors,
  ListBinItemsResponses,
  ListCredentialsData,
  ListCredentialsErrors,
  ListCredentialsResponses,
  ListCustomServicesData,
  ListCustomServicesErrors,
  ListCustomServicesResponses,
  ListDerivedAssetsData,
  ListDerivedAssetsErrors,
  ListDerivedAssetsResponses,
  ListLocatorRulesData,
  ListLocatorRulesErrors,
  ListLocatorRulesResponses,
  ListLoraBaseModelsData,
  ListLoraBaseModelsErrors,
  ListLoraBaseModelsResponses,
  ListLoraCheckpointsData,
  ListLoraCheckpointsErrors,
  ListLoraCheckpointsResponses,
  ListLoraKindsData,
  ListLoraKindsErrors,
  ListLoraKindsResponses,
  ListLorasData,
  ListLorasErrors,
  ListLorasResponses,
  ListLoraTrainingRunsData,
  ListLoraTrainingRunsErrors,
  ListLoraTrainingRunsResponses,
  ListNodeTypesData,
  ListNodeTypesResponses,
  ListNotificationsData,
  ListNotificationsErrors,
  ListNotificationsResponses,
  ListPendingInvitationsData,
  ListPendingInvitationsErrors,
  ListPendingInvitationsResponses,
  ListProjectsData,
  ListProjectsErrors,
  ListProjectSharesData,
  ListProjectSharesErrors,
  ListProjectSharesResponses,
  ListProjectsResponses,
  ListTeamsData,
  ListTeamsErrors,
  ListTeamsResponses,
  ListTimelineExportsData,
  ListTimelineExportsErrors,
  ListTimelineExportsResponses,
  ListTimelineVersionsData,
  ListTimelineVersionsErrors,
  ListTimelineVersionsResponses,
  ListWorkflowAssetsData,
  ListWorkflowAssetsErrors,
  ListWorkflowAssetsResponses,
  ListWorkflowExecutionsData,
  ListWorkflowExecutionsResponses,
  ListWorkflowsData,
  ListWorkflowsResponses,
  LockCreativeDirectionData,
  LockCreativeDirectionErrors,
  LockCreativeDirectionResponses,
  LogoutData,
  LogoutOtherSessionsData,
  LogoutOtherSessionsErrors,
  LogoutOtherSessionsResponses,
  LogoutResponses,
  MarkAllNotificationsReadData,
  MarkAllNotificationsReadErrors,
  MarkAllNotificationsReadResponses,
  MarkNotificationReadData,
  MarkNotificationReadErrors,
  MarkNotificationReadResponses,
  PreviewCustomServiceData,
  PreviewCustomServiceErrors,
  PreviewCustomServiceResponses,
  PurgeAssetData,
  PurgeAssetErrors,
  PurgeAssetResponses,
  PurgeProjectData,
  PurgeProjectErrors,
  PurgeProjectResponses,
  PurgeTeamData,
  PurgeTeamErrors,
  PurgeTeamResponses,
  PurgeVersionData,
  PurgeVersionErrors,
  PurgeVersionResponses,
  PurgeWorkflowData,
  PurgeWorkflowErrors,
  PurgeWorkflowResponses,
  RefreshTokenData,
  RefreshTokenErrors,
  RefreshTokenResponses,
  ReleaseLockData,
  ReleaseLockResponses,
  RemoveShotAssetData,
  RemoveShotAssetErrors,
  RemoveShotAssetResponses,
  ReorderScenesData,
  ReorderScenesErrors,
  ReorderScenesResponses,
  ReorderShotsData,
  ReorderShotsErrors,
  ReorderShotsResponses,
  ResolveInvitationTokenData,
  ResolveInvitationTokenErrors,
  ResolveInvitationTokenResponses,
  RestoreVersionData,
  RestoreVersionErrors,
  RestoreVersionResponses,
  RetryExecutionData,
  RetryExecutionResponses,
  RevokeProjectShareData,
  RevokeProjectShareErrors,
  RevokeProjectShareResponses,
  RevokeProjectSupportAccessData,
  RevokeProjectSupportAccessErrors,
  RevokeProjectSupportAccessResponses,
  RunShotNodeData,
  RunShotNodeErrors,
  RunShotNodeResponses,
  SearchData,
  SearchErrors,
  SearchResponses,
  SetDefaultCheckpointData,
  SetDefaultCheckpointErrors,
  SetDefaultCheckpointResponses,
  SetWorkflowShotTemplateData,
  SetWorkflowShotTemplateErrors,
  SetWorkflowShotTemplateResponses,
  ShareProjectData,
  ShareProjectErrors,
  ShareProjectResponses,
  StartCustomServiceInferenceData,
  StartCustomServiceInferenceErrors,
  StartCustomServiceInferenceResponses,
  StartLoraDatasetPrepData,
  StartLoraDatasetPrepErrors,
  StartLoraDatasetPrepResponses,
  SubmitLoraTrainingRunData,
  SubmitLoraTrainingRunErrors,
  SubmitLoraTrainingRunResponses,
  TransferLoraToTeamData,
  TransferLoraToTeamErrors,
  TransferLoraToTeamResponses,
  TransferLoraToUserData,
  TransferLoraToUserErrors,
  TransferLoraToUserResponses,
  UnapproveAssetData,
  UnapproveAssetErrors,
  UnapproveAssetResponses,
  UndeleteAssetData,
  UndeleteAssetErrors,
  UndeleteAssetResponses,
  UndeleteProjectData,
  UndeleteProjectErrors,
  UndeleteProjectResponses,
  UndeleteTeamData,
  UndeleteTeamErrors,
  UndeleteTeamResponses,
  UndeleteVersionData,
  UndeleteVersionErrors,
  UndeleteVersionResponses,
  UndeleteWorkflowData,
  UndeleteWorkflowErrors,
  UndeleteWorkflowResponses,
  UnlockCreativeDirectionData,
  UnlockCreativeDirectionErrors,
  UnlockCreativeDirectionResponses,
  UpdateAssetData,
  UpdateAssetErrors,
  UpdateAssetResponses,
  UpdateCreativeDirectionData,
  UpdateCreativeDirectionErrors,
  UpdateCreativeDirectionResponses,
  UpdateCustomServiceData,
  UpdateCustomServiceErrors,
  UpdateCustomServiceResponses,
  UpdateDerivedAssetStatusData,
  UpdateDerivedAssetStatusErrors,
  UpdateDerivedAssetStatusResponses,
  UpdateLoraData,
  UpdateLoraDatasetCaptionData,
  UpdateLoraDatasetCaptionErrors,
  UpdateLoraDatasetCaptionResponses,
  UpdateLoraErrors,
  UpdateLoraResponses,
  UpdateNotificationPreferencesData,
  UpdateNotificationPreferencesErrors,
  UpdateNotificationPreferencesResponses,
  UpdateProjectData,
  UpdateProjectErrors,
  UpdateProjectResponses,
  UpdateProjectShareRoleData,
  UpdateProjectShareRoleErrors,
  UpdateProjectShareRoleResponses,
  UpdateSceneData,
  UpdateSceneErrors,
  UpdateSceneResponses,
  UpdateShotData,
  UpdateShotErrors,
  UpdateShotNodeData,
  UpdateShotNodeErrors,
  UpdateShotNodeResponses,
  UpdateShotResponses,
  UpdateTeamData,
  UpdateTeamErrors,
  UpdateTeamResponses,
  UpdateTimelineData,
  UpdateTimelineErrors,
  UpdateTimelineResponses,
  UpdateWorkflowData,
  UpdateWorkflowResponses,
  UploadAssetData,
  UploadAssetErrors,
  UploadAssetResponses,
  WithdrawProjectInvitationData,
  WithdrawProjectInvitationErrors,
  WithdrawProjectInvitationResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Google OAuth login
 */
export const googleLogin = <ThrowOnError extends boolean = false>(
  options: Options<GoogleLoginData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GoogleLoginResponses,
    GoogleLoginErrors,
    ThrowOnError
  >({
    url: "/v1/auth/google",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Refresh access token
 */
export const refreshToken = <ThrowOnError extends boolean = false>(
  options: Options<RefreshTokenData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefreshTokenResponses,
    RefreshTokenErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/auth/refresh",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * User logout
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/auth/logout",
    ...options,
  });

/**
 * Sign out all other sessions
 *
 * Terminates all sessions for the current user except the one making the request. This is a security feature enabling users to remotely log out from all other devices/browsers.
 */
export const logoutOtherSessions = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutOtherSessionsData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    LogoutOtherSessionsResponses,
    LogoutOtherSessionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/auth/sessions/others",
    ...options,
  });

/**
 * Get current user details
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetCurrentUserResponses,
    GetCurrentUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/users/me",
    ...options,
  });

/**
 * List user's teams
 */
export const listTeams = <ThrowOnError extends boolean = false>(
  options?: Options<ListTeamsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListTeamsResponses,
    ListTeamsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/teams",
    ...options,
  });

/**
 * Create new team
 */
export const createTeam = <ThrowOnError extends boolean = false>(
  options: Options<CreateTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateTeamResponses,
    CreateTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/teams",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete team (soft delete)
 */
export const deleteTeam = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTeamData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteTeamResponses,
    DeleteTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/teams/{teamId}",
    ...options,
  });

/**
 * Get team details
 */
export const getTeam = <ThrowOnError extends boolean = false>(
  options: Options<GetTeamData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTeamResponses, GetTeamErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v1/teams/{teamId}",
      ...options,
    },
  );

/**
 * Update team
 */
export const updateTeam = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTeamData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateTeamResponses,
    UpdateTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/teams/{teamId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore soft-deleted team
 */
export const undeleteTeam = <ThrowOnError extends boolean = false>(
  options: Options<UndeleteTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UndeleteTeamResponses,
    UndeleteTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/teams/{teamId}/undelete",
    ...options,
  });

/**
 * Permanently delete team
 */
export const purgeTeam = <ThrowOnError extends boolean = false>(
  options: Options<PurgeTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PurgeTeamResponses,
    PurgeTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/teams/{teamId}/purge",
    ...options,
  });

/**
 * List user's accessible projects
 */
export const listProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListProjectsResponses,
    ListProjectsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects",
    ...options,
  });

/**
 * Create project
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateProjectResponses,
    CreateProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete project (soft delete)
 */
export const deleteProject = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteProjectResponses,
    DeleteProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}",
    ...options,
  });

/**
 * Get project details
 */
export const getProject = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectResponses,
    GetProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}",
    ...options,
  });

/**
 * Update project
 */
export const updateProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateProjectResponses,
    UpdateProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore soft-deleted project
 */
export const undeleteProject = <ThrowOnError extends boolean = false>(
  options: Options<UndeleteProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UndeleteProjectResponses,
    UndeleteProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/undelete",
    ...options,
  });

/**
 * Permanently delete project
 */
export const purgeProject = <ThrowOnError extends boolean = false>(
  options: Options<PurgeProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PurgeProjectResponses,
    PurgeProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/purge",
    ...options,
  });

/**
 * Get CloudFront signed cookies for project assets
 *
 * Emits three `Set-Cookie` headers (`CloudFront-Policy`, `CloudFront-Signature`,
 * `CloudFront-Key-Pair-Id`) as `HttpOnly; Secure; SameSite=Lax` cookies scoped
 * to the configured parent domain (e.g. `.stud1o.net`). The browser then sends
 * them automatically on asset requests to `assets.<env>`, so no signature
 * material appears in URL query strings.
 *
 * The response body returns `{ domain, expiresAt, projectPrefix }` only —
 * cookie values are NOT exposed to JavaScript.
 *
 */
export const createSignedCookies = <ThrowOnError extends boolean = false>(
  options: Options<CreateSignedCookiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateSignedCookiesResponses,
    CreateSignedCookiesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/signed-cookies",
    ...options,
  });

/**
 * List entitlement policies applicable to a project
 *
 * Returns the entitlement policies applicable to the given project
 * (org-scope, project-scope, and team-scope). Authorised via project
 * access (action__read__entitlement_policy + projectId), NOT org
 * membership — so team-only external users can read policies on
 * projects they have access to.
 *
 * See power #228 and docs/plans/entitlement-policy-consumer-read-api.md.
 *
 */
export const getProjectApplicableEntitlementPolicies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectApplicableEntitlementPoliciesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectApplicableEntitlementPoliciesResponses,
    GetProjectApplicableEntitlementPoliciesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/applicable-entitlement-policies",
    ...options,
  });

/**
 * List project's assets
 */
export const listAssets = <ThrowOnError extends boolean = false>(
  options: Options<ListAssetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListAssetsResponses,
    ListAssetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/assets",
    ...options,
  });

/**
 * Upload asset file to project
 */
export const uploadAsset = <ThrowOnError extends boolean = false>(
  options: Options<UploadAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadAssetResponses,
    UploadAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/assets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Initiate presigned URL upload for large files
 *
 * Initiates a presigned URL upload flow for large files (>10MB).
 * Returns a presigned S3 URL for direct upload, bypassing API body size limits.
 * After uploading to S3, call confirm-upload to finalize the asset.
 *
 */
export const initiateAssetUpload = <ThrowOnError extends boolean = false>(
  options: Options<InitiateAssetUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InitiateAssetUploadResponses,
    InitiateAssetUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/assets/initiate-upload",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confirm presigned URL upload
 *
 * Confirms that a file has been uploaded to S3 via presigned URL.
 * Verifies the file exists in S3 and transitions the asset to active status.
 *
 */
export const confirmAssetUpload = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmAssetUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ConfirmAssetUploadResponses,
    ConfirmAssetUploadErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/assets/confirm-upload",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete asset (soft delete)
 */
export const deleteAsset = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAssetData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAssetResponses,
    DeleteAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}",
    ...options,
  });

/**
 * Get asset details
 */
export const getAsset = <ThrowOnError extends boolean = false>(
  options: Options<GetAssetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssetResponses,
    GetAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}",
    ...options,
  });

/**
 * Update asset settings
 */
export const updateAsset = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAssetData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateAssetResponses,
    UpdateAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore soft-deleted asset
 */
export const undeleteAsset = <ThrowOnError extends boolean = false>(
  options: Options<UndeleteAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UndeleteAssetResponses,
    UndeleteAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}/undelete",
    ...options,
  });

/**
 * Permanently delete asset
 */
export const purgeAsset = <ThrowOnError extends boolean = false>(
  options: Options<PurgeAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PurgeAssetResponses,
    PurgeAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}/purge",
    ...options,
  });

/**
 * List derived assets for a parent asset
 */
export const listDerivedAssets = <ThrowOnError extends boolean = false>(
  options: Options<ListDerivedAssetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListDerivedAssetsResponses,
    ListDerivedAssetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}/derived",
    ...options,
  });

/**
 * Create a derived asset group (internal/orchestrator)
 */
export const createDerivedAsset = <ThrowOnError extends boolean = false>(
  options: Options<CreateDerivedAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateDerivedAssetResponses,
    CreateDerivedAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}/derived",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update derived asset processing status
 */
export const updateDerivedAssetStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDerivedAssetStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateDerivedAssetStatusResponses,
    UpdateDerivedAssetStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/derived-assets/{derivedAssetId}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all active asset locator rules
 */
export const listLocatorRules = <ThrowOnError extends boolean = false>(
  options?: Options<ListLocatorRulesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListLocatorRulesResponses,
    ListLocatorRulesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/locator-rules",
    ...options,
  });

/**
 * Generate video chunks from asset
 *
 * Creates a derived asset record and enqueues an FFmpeg chunking job
 * to the orchestrator for async processing. Returns 202 Accepted immediately.
 * The asset must be a video file.
 *
 */
export const generateVideoChunks = <ThrowOnError extends boolean = false>(
  options: Options<GenerateVideoChunksData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateVideoChunksResponses,
    GenerateVideoChunksErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}/generate-chunks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Generate thumbnail from video asset
 *
 * Creates a derived asset record and enqueues an FFmpeg thumbnail job
 * to the orchestrator for async processing. Returns 202 Accepted immediately.
 * The asset must be a video file.
 *
 */
export const generateThumbnail = <ThrowOnError extends boolean = false>(
  options: Options<GenerateThumbnailData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateThumbnailResponses,
    GenerateThumbnailErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}/generate-thumbnail",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Generate filmstrip sprite sheet from video asset
 *
 * Creates a derived asset record and enqueues an FFmpeg filmstrip job
 * to the orchestrator for async processing. Returns 202 Accepted immediately.
 * The asset must be a video file.
 *
 * A filmstrip is a horizontal sprite sheet containing evenly-spaced frames
 * from the video, useful for timeline scrubbing previews.
 *
 */
export const generateFilmstrip = <ThrowOnError extends boolean = false>(
  options: Options<GenerateFilmstripData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateFilmstripResponses,
    GenerateFilmstripErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/assets/{assetId}/generate-filmstrip",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List workflows in a project
 */
export const listWorkflows = <ThrowOnError extends boolean = false>(
  options: Options<ListWorkflowsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ListWorkflowsResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v1/projects/{projectId}/workflows",
      ...options,
    },
  );

/**
 * Create a new workflow
 */
export const createWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<CreateWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateWorkflowResponses,
    CreateWorkflowErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/workflows",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete workflow (soft delete)
 */
export const deleteWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteWorkflowResponses,
    DeleteWorkflowErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}",
    ...options,
  });

/**
 * Get workflow details
 */
export const getWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetWorkflowResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}",
    ...options,
  });

/**
 * Update workflow
 */
export const updateWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateWorkflowResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore soft-deleted workflow
 */
export const undeleteWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<UndeleteWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UndeleteWorkflowResponses,
    UndeleteWorkflowErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/undelete",
    ...options,
  });

/**
 * Permanently delete workflow
 */
export const purgeWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<PurgeWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PurgeWorkflowResponses,
    PurgeWorkflowErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/purge",
    ...options,
  });

/**
 * Duplicate workflow
 */
export const duplicateWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DuplicateWorkflowResponses,
    DuplicateWorkflowErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/duplicate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get version history
 */
export const getVersionHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetVersionHistoryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetVersionHistoryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/versions",
    ...options,
  });

/**
 * Delete version (soft delete)
 */
export const deleteVersion = <ThrowOnError extends boolean = false>(
  options: Options<DeleteVersionData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteVersionResponses,
    DeleteVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflow-versions/{versionId}",
    ...options,
  });

/**
 * Get specific version
 */
export const getVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetVersionData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflow-versions/{versionId}",
    ...options,
  });

/**
 * Restore version (promote to current)
 */
export const restoreVersion = <ThrowOnError extends boolean = false>(
  options: Options<RestoreVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RestoreVersionResponses,
    RestoreVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflow-versions/{versionId}/restore",
    ...options,
  });

/**
 * Restore soft-deleted version
 */
export const undeleteVersion = <ThrowOnError extends boolean = false>(
  options: Options<UndeleteVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UndeleteVersionResponses,
    UndeleteVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflow-versions/{versionId}/undelete",
    ...options,
  });

/**
 * Permanently delete version
 */
export const purgeVersion = <ThrowOnError extends boolean = false>(
  options: Options<PurgeVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PurgeVersionResponses,
    PurgeVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflow-versions/{versionId}/purge",
    ...options,
  });

/**
 * Release workflow lock
 */
export const releaseLock = <ThrowOnError extends boolean = false>(
  options: Options<ReleaseLockData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ReleaseLockResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/lock",
    ...options,
  });

/**
 * Acquire or renew workflow lock
 */
export const acquireLock = <ThrowOnError extends boolean = false>(
  options: Options<AcquireLockData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcquireLockResponses,
    AcquireLockErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/lock",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List node types
 */
export const listNodeTypes = <ThrowOnError extends boolean = false>(
  options?: Options<ListNodeTypesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListNodeTypesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/node-types",
    ...options,
  });

/**
 * Get node type details
 */
export const getNodeType = <ThrowOnError extends boolean = false>(
  options: Options<GetNodeTypeData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetNodeTypeResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/node-types/{nodeTypeSlug}",
    ...options,
  });

/**
 * Get node type parameters
 */
export const getNodeTypeParameters = <ThrowOnError extends boolean = false>(
  options: Options<GetNodeTypeParametersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetNodeTypeParametersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/node-types/{nodeTypeSlug}/parameters",
    ...options,
  });

/**
 * Execute full workflow
 */
export const executeWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<ExecuteWorkflowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ExecuteWorkflowResponses,
    ExecuteWorkflowErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/execute",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List workflow executions
 */
export const listWorkflowExecutions = <ThrowOnError extends boolean = false>(
  options: Options<ListWorkflowExecutionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListWorkflowExecutionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/executions",
    ...options,
  });

/**
 * List workflow's assets
 */
export const listWorkflowAssets = <ThrowOnError extends boolean = false>(
  options: Options<ListWorkflowAssetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListWorkflowAssetsResponses,
    ListWorkflowAssetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/assets",
    ...options,
  });

/**
 * Get execution status
 */
export const getExecutionStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetExecutionStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetExecutionStatusResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/executions/{executionId}",
    ...options,
  });

/**
 * Cancel execution
 */
export const cancelExecution = <ThrowOnError extends boolean = false>(
  options: Options<CancelExecutionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CancelExecutionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/executions/{executionId}/cancel",
    ...options,
  });

/**
 * Retry failed execution
 */
export const retryExecution = <ThrowOnError extends boolean = false>(
  options: Options<RetryExecutionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RetryExecutionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/executions/{executionId}/retry",
    ...options,
  });

/**
 * Get execution logs
 */
export const getExecutionLogs = <ThrowOnError extends boolean = false>(
  options: Options<GetExecutionLogsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetExecutionLogsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/executions/{executionId}/logs",
    ...options,
  });

/**
 * List project shares and pending invitations
 *
 * Returns all teams that have access to the project (shares) and
 * all pending invitations that have not yet been accepted or declined.
 *
 */
export const listProjectShares = <ThrowOnError extends boolean = false>(
  options: Options<ListProjectSharesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListProjectSharesResponses,
    ListProjectSharesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shares",
    ...options,
  });

/**
 * Share project with another user via email invitation
 *
 * Sends an email invitation to share the project with another user.
 * The invited user receives an email with a magic link to accept.
 *
 */
export const shareProject = <ThrowOnError extends boolean = false>(
  options: Options<ShareProjectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ShareProjectResponses,
    ShareProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shares",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Revoke a team's access to a project
 *
 * Removes the specified team's access to the project. The team will
 * no longer be able to view or edit the project.
 *
 */
export const revokeProjectShare = <ThrowOnError extends boolean = false>(
  options: Options<RevokeProjectShareData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RevokeProjectShareResponses,
    RevokeProjectShareErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shares/{teamId}",
    ...options,
  });

/**
 * Update a team's role on a project share
 *
 * Changes the role assigned to a team for a given project share.
 * For example, promote a team from editor to owner, or demote from
 * owner to editor.
 *
 */
export const updateProjectShareRole = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectShareRoleData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateProjectShareRoleResponses,
    UpdateProjectShareRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shares/{teamId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Withdraw a pending invitation
 *
 * Cancels a pending invitation that was sent to share a project.
 * Only the project owner can withdraw invitations.
 *
 */
export const withdrawProjectInvitation = <ThrowOnError extends boolean = false>(
  options: Options<WithdrawProjectInvitationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    WithdrawProjectInvitationResponses,
    WithdrawProjectInvitationErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/invitations/{invitationId}",
    ...options,
  });

/**
 * List current user's pending invitations
 *
 * Returns all pending project invitations for the authenticated user.
 * These are invitations that have been sent to the user's email address
 * and have not yet been accepted or declined.
 *
 */
export const listPendingInvitations = <ThrowOnError extends boolean = false>(
  options?: Options<ListPendingInvitationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListPendingInvitationsResponses,
    ListPendingInvitationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/invitations/pending",
    ...options,
  });

/**
 * Resolve an invitation token (public, no auth required)
 *
 * Resolves an invitation token to its details (project name, inviter, role).
 * This endpoint is public so unauthenticated users can see invitation details
 * before logging in or signing up.
 *
 */
export const resolveInvitationToken = <ThrowOnError extends boolean = false>(
  options: Options<ResolveInvitationTokenData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ResolveInvitationTokenResponses,
    ResolveInvitationTokenErrors,
    ThrowOnError
  >({ url: "/v1/invitations/resolve/{token}", ...options });

/**
 * Accept a project invitation
 *
 * Accepts a pending invitation, granting the user's team access to the
 * project with the specified role (editor or viewer).
 *
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(
  options: Options<AcceptInvitationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcceptInvitationResponses,
    AcceptInvitationErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/invitations/{invitationId}/accept",
    ...options,
  });

/**
 * Decline a project invitation
 *
 * Declines a pending invitation. The project will not be shared with
 * the user's team.
 *
 */
export const declineInvitation = <ThrowOnError extends boolean = false>(
  options: Options<DeclineInvitationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DeclineInvitationResponses,
    DeclineInvitationErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/invitations/{invitationId}/decline",
    ...options,
  });

/**
 * List timelines in a project
 */
export const getProjectTimelines = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectTimelinesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectTimelinesResponses,
    GetProjectTimelinesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/timelines",
    ...options,
  });

/**
 * Create a new timeline
 */
export const createTimeline = <ThrowOnError extends boolean = false>(
  options: Options<CreateTimelineData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateTimelineResponses,
    CreateTimelineErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/timelines",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get timeline details
 */
export const getTimeline = <ThrowOnError extends boolean = false>(
  options: Options<GetTimelineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetTimelineResponses,
    GetTimelineErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}",
    ...options,
  });

/**
 * Update timeline
 */
export const updateTimeline = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTimelineData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateTimelineResponses,
    UpdateTimelineErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List timeline versions
 */
export const listTimelineVersions = <ThrowOnError extends boolean = false>(
  options: Options<ListTimelineVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListTimelineVersionsResponses,
    ListTimelineVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}/versions",
    ...options,
  });

/**
 * Create a new timeline version
 */
export const createTimelineVersion = <ThrowOnError extends boolean = false>(
  options: Options<CreateTimelineVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateTimelineVersionResponses,
    CreateTimelineVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete timeline version (soft delete)
 */
export const deleteTimelineVersion = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTimelineVersionData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteTimelineVersionResponses,
    DeleteTimelineVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timeline-versions/{versionId}",
    ...options,
  });

/**
 * Get timeline version details
 */
export const getTimelineVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetTimelineVersionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetTimelineVersionResponses,
    GetTimelineVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timeline-versions/{versionId}",
    ...options,
  });

/**
 * Release timeline lock
 *
 * Releases the exclusive edit lock on a timeline held by the authenticated user.
 */
export const deleteTimelineLock = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTimelineLockData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteTimelineLockResponses,
    DeleteTimelineLockErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}/lock",
    ...options,
  });

/**
 * Acquire timeline lock
 *
 * Acquires an exclusive edit lock on a timeline for the authenticated user.
 */
export const createTimelineLock = <ThrowOnError extends boolean = false>(
  options: Options<CreateTimelineLockData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateTimelineLockResponses,
    CreateTimelineLockErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}/lock",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a timeline export
 *
 * Initiates a new timeline export job. The export is processed asynchronously and the response includes the export record with a queued status.
 */
export const createTimelineExport = <ThrowOnError extends boolean = false>(
  options: Options<CreateTimelineExportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateTimelineExportResponses,
    CreateTimelineExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/timelines/{timelineId}/export",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List timeline exports
 *
 * Returns a paginated list of exports for a specific timeline within a project.
 */
export const listTimelineExports = <ThrowOnError extends boolean = false>(
  options: Options<ListTimelineExportsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListTimelineExportsResponses,
    ListTimelineExportsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/timelines/{timelineId}/exports",
    ...options,
  });

/**
 * Get timeline export details
 *
 * Returns the details of a specific timeline export including its current status and progress.
 */
export const getTimelineExport = <ThrowOnError extends boolean = false>(
  options: Options<GetTimelineExportData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetTimelineExportResponses,
    GetTimelineExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}/export/{exportId}",
    ...options,
  });

/**
 * Delete a timeline export
 *
 * Soft-deletes a timeline export. Only terminal-state exports (completed, failed, cancelled) can be deleted. In-progress exports must be cancelled first.
 */
export const deleteTimelineExport = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTimelineExportData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteTimelineExportResponses,
    DeleteTimelineExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timeline-versions/{timelineVersionId}/export/{timelineExportId}",
    ...options,
  });

/**
 * Cancel a timeline export
 *
 * Cancels a timeline export that is currently in progress or queued.
 */
export const cancelTimelineExport = <ThrowOnError extends boolean = false>(
  options: Options<CancelTimelineExportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CancelTimelineExportResponses,
    CancelTimelineExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/timelines/{timelineId}/export/{exportId}/cancel",
    ...options,
  });

/**
 * Clear completed timeline exports
 *
 * Soft-deletes all terminal-state exports (completed, failed, cancelled) for a timeline.
 */
export const clearCompletedTimelineExports = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClearCompletedTimelineExportsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ClearCompletedTimelineExportsResponses,
    ClearCompletedTimelineExportsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/timelines/{timelineId}/exports/clear-completed",
    ...options,
  });

/**
 * List notifications for the authenticated user
 *
 * Returns a paginated list of notifications for the current user.
 * Supports filtering by read status and category.
 *
 */
export const listNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<ListNotificationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListNotificationsResponses,
    ListNotificationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/notifications",
    ...options,
  });

/**
 * Get unread notification count
 *
 * Returns the number of unread notifications for the authenticated user.
 */
export const getNotificationUnreadCount = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetNotificationUnreadCountData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetNotificationUnreadCountResponses,
    GetNotificationUnreadCountErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/notifications/unread-count",
    ...options,
  });

/**
 * Mark all notifications as read
 *
 * Marks all unread notifications as read for the authenticated user.
 */
export const markAllNotificationsRead = <ThrowOnError extends boolean = false>(
  options?: Options<MarkAllNotificationsReadData, ThrowOnError>,
) =>
  (options?.client ?? client).patch<
    MarkAllNotificationsReadResponses,
    MarkAllNotificationsReadErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/notifications/read-all",
    ...options,
  });

/**
 * Get notification preferences
 *
 * Returns the notification preferences for the authenticated user.
 */
export const getNotificationPreferences = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetNotificationPreferencesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetNotificationPreferencesResponses,
    GetNotificationPreferencesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/notifications/preferences",
    ...options,
  });

/**
 * Update notification preferences
 *
 * Updates one or more notification preferences for the authenticated user. At least one field must be provided.
 */
export const updateNotificationPreferences = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateNotificationPreferencesData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateNotificationPreferencesResponses,
    UpdateNotificationPreferencesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/notifications/preferences",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Mark a single notification as read
 *
 * Marks a specific notification as read by its ID.
 */
export const markNotificationRead = <ThrowOnError extends boolean = false>(
  options: Options<MarkNotificationReadData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    MarkNotificationReadResponses,
    MarkNotificationReadErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/notifications/{notificationId}/read",
    ...options,
  });

/**
 * Delete a notification
 *
 * Soft-deletes a notification by its ID.
 */
export const deleteNotification = <ThrowOnError extends boolean = false>(
  options: Options<DeleteNotificationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteNotificationResponses,
    DeleteNotificationErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/notifications/{notificationId}",
    ...options,
  });

/**
 * Search across projects and workflows
 */
export const search = <ThrowOnError extends boolean = false>(
  options?: Options<SearchData, ThrowOnError>,
) =>
  (options?.client ?? client).get<SearchResponses, SearchErrors, ThrowOnError>({
    querySerializer: {
      parameters: {
        entityTypes: { array: { explode: false } },
        attributes: { array: { explode: false } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/search",
    ...options,
  });

/**
 * Get available search filter dimensions and values
 */
export const getSearchFilters = <ThrowOnError extends boolean = false>(
  options?: Options<GetSearchFiltersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSearchFiltersResponses,
    GetSearchFiltersErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/search/filters",
    ...options,
  });

/**
 * List bin items (soft-deleted entities)
 *
 * Returns all soft-deleted entities (projects, workflows, assets) in the
 * user's bin, enriched with entity names, thumbnails, and deletion metadata.
 * Items are ordered by deletion date (newest first).
 *
 */
export const listBinItems = <ThrowOnError extends boolean = false>(
  options?: Options<ListBinItemsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListBinItemsResponses,
    ListBinItemsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/bin",
    ...options,
  });

/**
 * List credentials (metadata only)
 *
 * Returns all credentials owned by the caller's organisation. Encrypted
 * secret material is never returned — only metadata such as name, provider
 * type, status, and timestamps.
 *
 */
export const listCredentials = <ThrowOnError extends boolean = false>(
  options?: Options<ListCredentialsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListCredentialsResponses,
    ListCredentialsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/credentials",
    ...options,
  });

/**
 * Create encrypted credential
 *
 * Stores an API key for an external provider, encrypted at rest. The
 * plaintext key is never returned in any subsequent response.
 *
 */
export const createCredential = <ThrowOnError extends boolean = false>(
  options: Options<CreateCredentialData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCredentialResponses,
    CreateCredentialErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/credentials",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Soft-delete (revoke) credential
 */
export const deleteCredential = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCredentialData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteCredentialResponses,
    DeleteCredentialErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/credentials/{id}",
    ...options,
  });

/**
 * List custom services for caller's organisation
 */
export const listCustomServices = <ThrowOnError extends boolean = false>(
  options?: Options<ListCustomServicesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListCustomServicesResponses,
    ListCustomServicesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services",
    ...options,
  });

/**
 * Create draft custom service
 *
 * Creates a new custom-service draft. Inference may be started subsequently
 * via `POST /v1/custom-services/{id}/infer`.
 *
 */
export const createCustomService = <ThrowOnError extends boolean = false>(
  options: Options<CreateCustomServiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCustomServiceResponses,
    CreateCustomServiceErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get single custom service
 */
export const getCustomService = <ThrowOnError extends boolean = false>(
  options: Options<GetCustomServiceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCustomServiceResponses,
    GetCustomServiceErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services/{id}",
    ...options,
  });

/**
 * Update draft fields
 */
export const updateCustomService = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCustomServiceData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpdateCustomServiceResponses,
    UpdateCustomServiceErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Transition custom service from Draft to Active
 */
export const activateCustomService = <ThrowOnError extends boolean = false>(
  options: Options<ActivateCustomServiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ActivateCustomServiceResponses,
    ActivateCustomServiceErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services/{id}/activate",
    ...options,
  });

/**
 * Transition custom service from Active to Disabled
 */
export const disableCustomService = <ThrowOnError extends boolean = false>(
  options: Options<DisableCustomServiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DisableCustomServiceResponses,
    DisableCustomServiceErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services/{id}/disable",
    ...options,
  });

/**
 * Start the 6-phase inference engine
 *
 * Enqueues the inference job to the orchestrator. Progress and questions
 * are published via the WebSocket channel `custom-service.infer.*`.
 *
 */
export const startCustomServiceInference = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StartCustomServiceInferenceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartCustomServiceInferenceResponses,
    StartCustomServiceInferenceErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services/{id}/infer",
    ...options,
  });

/**
 * Answer an inference question
 *
 * Records an answer to an outstanding inference question and unblocks the
 * waiting orchestrator worker.
 *
 */
export const answerInferenceQuestion = <ThrowOnError extends boolean = false>(
  options: Options<AnswerInferenceQuestionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AnswerInferenceQuestionResponses,
    AnswerInferenceQuestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services/{id}/answer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Preview a custom-service invocation (ephemeral, no persistence)
 *
 * Issues a one-shot request to the configured endpoint with the supplied
 * test inputs and parameter overrides, returning the raw + mapped response
 * for inspection. Nothing is persisted.
 *
 */
export const previewCustomService = <ThrowOnError extends boolean = false>(
  options: Options<PreviewCustomServiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PreviewCustomServiceResponses,
    PreviewCustomServiceErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/custom-services/{id}/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List scenes for a project
 */
export const getScenes = <ThrowOnError extends boolean = false>(
  options: Options<GetScenesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetScenesResponses,
    GetScenesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/scenes",
    ...options,
  });

/**
 * Create a scene
 */
export const createScene = <ThrowOnError extends boolean = false>(
  options: Options<CreateSceneData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateSceneResponses,
    CreateSceneErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/scenes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reorder scenes within a project
 */
export const reorderScenes = <ThrowOnError extends boolean = false>(
  options: Options<ReorderScenesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReorderScenesResponses,
    ReorderScenesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/scenes/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a scene
 */
export const deleteScene = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSceneData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteSceneResponses,
    DeleteSceneErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/scenes/{sceneId}",
    ...options,
  });

/**
 * Update a scene
 */
export const updateScene = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSceneData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateSceneResponses,
    UpdateSceneErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/scenes/{sceneId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a shot
 */
export const createShot = <ThrowOnError extends boolean = false>(
  options: Options<CreateShotData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateShotResponses,
    CreateShotErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Reorder shots across scenes within a project
 */
export const reorderShots = <ThrowOnError extends boolean = false>(
  options: Options<ReorderShotsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReorderShotsResponses,
    ReorderShotsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/reorder",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a shot
 */
export const deleteShot = <ThrowOnError extends boolean = false>(
  options: Options<DeleteShotData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteShotResponses,
    DeleteShotErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/shots/{shotId}",
    ...options,
  });

/**
 * Get shot details
 */
export const getShot = <ThrowOnError extends boolean = false>(
  options: Options<GetShotData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetShotResponses, GetShotErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v1/shots/{shotId}",
      ...options,
    },
  );

/**
 * Update a shot
 */
export const updateShot = <ThrowOnError extends boolean = false>(
  options: Options<UpdateShotData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateShotResponses,
    UpdateShotErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/shots/{shotId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List assets attached to a shot
 */
export const getShotAssets = <ThrowOnError extends boolean = false>(
  options: Options<GetShotAssetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetShotAssetsResponses,
    GetShotAssetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/assets",
    ...options,
  });

/**
 * Attach an asset to a shot
 */
export const addShotAsset = <ThrowOnError extends boolean = false>(
  options: Options<AddShotAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddShotAssetResponses,
    AddShotAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/assets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Detach an asset from a shot
 */
export const removeShotAsset = <ThrowOnError extends boolean = false>(
  options: Options<RemoveShotAssetData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RemoveShotAssetResponses,
    RemoveShotAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/assets/{assetId}",
    ...options,
  });

/**
 * Approve an asset
 */
export const approveAsset = <ThrowOnError extends boolean = false>(
  options: Options<ApproveAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApproveAssetResponses,
    ApproveAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/assets/{assetId}/approve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unapprove an asset
 */
export const unapproveAsset = <ThrowOnError extends boolean = false>(
  options: Options<UnapproveAssetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UnapproveAssetResponses,
    UnapproveAssetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/assets/{assetId}/unapprove",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get creative direction for a shot
 */
export const getCreativeDirection = <ThrowOnError extends boolean = false>(
  options: Options<GetCreativeDirectionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCreativeDirectionResponses,
    GetCreativeDirectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/creative-direction",
    ...options,
  });

/**
 * Update creative direction for a shot
 */
export const updateCreativeDirection = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCreativeDirectionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateCreativeDirectionResponses,
    UpdateCreativeDirectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/creative-direction",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Lock creative direction for a shot
 */
export const lockCreativeDirection = <ThrowOnError extends boolean = false>(
  options: Options<LockCreativeDirectionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    LockCreativeDirectionResponses,
    LockCreativeDirectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/creative-direction/lock",
    ...options,
  });

/**
 * Unlock creative direction for a shot
 */
export const unlockCreativeDirection = <ThrowOnError extends boolean = false>(
  options: Options<UnlockCreativeDirectionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UnlockCreativeDirectionResponses,
    UnlockCreativeDirectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/creative-direction/unlock",
    ...options,
  });

/**
 * Get audit history for a shot
 */
export const getShotAudit = <ThrowOnError extends boolean = false>(
  options: Options<GetShotAuditData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetShotAuditResponses,
    GetShotAuditErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/shots/{shotId}/audit",
    ...options,
  });

/**
 * List nodes for a shot
 */
export const getShotNodes = <ThrowOnError extends boolean = false>(
  options: Options<GetShotNodesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetShotNodesResponses,
    GetShotNodesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/shots/{shotId}/nodes",
    ...options,
  });

/**
 * Get detail for a single shot node
 */
export const getShotNodeDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetShotNodeDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetShotNodeDetailResponses,
    GetShotNodeDetailErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/shots/{shotId}/nodes/{nodeKey}",
    ...options,
  });

/**
 * Update settings for a shot node
 */
export const updateShotNode = <ThrowOnError extends boolean = false>(
  options: Options<UpdateShotNodeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateShotNodeResponses,
    UpdateShotNodeErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/shots/{shotId}/nodes/{nodeKey}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Run a shot node
 */
export const runShotNode = <ThrowOnError extends boolean = false>(
  options: Options<RunShotNodeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RunShotNodeResponses,
    RunShotNodeErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/shots/{shotId}/nodes/{nodeKey}/run",
    ...options,
  });

/**
 * List workflow templates available to a project
 */
export const getWorkflowTemplates = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWorkflowTemplatesResponses,
    GetWorkflowTemplatesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/projects/{projectId}/workflow-templates",
    ...options,
  });

/**
 * Mark or unmark a workflow as a shot template
 */
export const setWorkflowShotTemplate = <ThrowOnError extends boolean = false>(
  options: Options<SetWorkflowShotTemplateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    SetWorkflowShotTemplateResponses,
    SetWorkflowShotTemplateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/workflows/{workflowId}/shot-template",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List LoRAs visible to the caller (owned + team-shared)
 */
export const listLoras = <ThrowOnError extends boolean = false>(
  options?: Options<ListLorasData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListLorasResponses,
    ListLorasErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras",
    ...options,
  });

/**
 * Create a LoRA + its auto-managed hidden dataset project
 */
export const createLora = <ThrowOnError extends boolean = false>(
  options: Options<CreateLoraData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateLoraResponses,
    CreateLoraErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Archive a LoRA (soft delete; cascades to dataset project)
 */
export const deleteLora = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLoraData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteLoraResponses,
    DeleteLoraErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}",
    ...options,
  });

/**
 * Get LoRA detail with embedded trainingRuns + checkpoints
 */
export const getLora = <ThrowOnError extends boolean = false>(
  options: Options<GetLoraData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetLoraResponses, GetLoraErrors, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/v1/loras/{loraId}",
      ...options,
    },
  );

/**
 * Update a LoRA (name / description / trigger word / cover asset)
 */
export const updateLora = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLoraData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateLoraResponses,
    UpdateLoraErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Transfer LoRA ownership from user-private to team-shared
 */
export const transferLoraToTeam = <ThrowOnError extends boolean = false>(
  options: Options<TransferLoraToTeamData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TransferLoraToTeamResponses,
    TransferLoraToTeamErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/transfer-to-team",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Transfer LoRA ownership from team-shared back to user-private
 */
export const transferLoraToUser = <ThrowOnError extends boolean = false>(
  options: Options<TransferLoraToUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TransferLoraToUserResponses,
    TransferLoraToUserErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/transfer-to-user",
    ...options,
  });

/**
 * Pin a specific checkpoint as the LoRA's default inference target
 */
export const setDefaultCheckpoint = <ThrowOnError extends boolean = false>(
  options: Options<SetDefaultCheckpointData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    SetDefaultCheckpointResponses,
    SetDefaultCheckpointErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/default-checkpoint",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all checkpoints emitted across the LoRA's training runs
 */
export const listLoraCheckpoints = <ThrowOnError extends boolean = false>(
  options: Options<ListLoraCheckpointsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListLoraCheckpointsResponses,
    ListLoraCheckpointsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/checkpoints",
    ...options,
  });

/**
 * List a LoRA's training runs (most-recent first)
 */
export const listLoraTrainingRuns = <ThrowOnError extends boolean = false>(
  options: Options<ListLoraTrainingRunsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListLoraTrainingRunsResponses,
    ListLoraTrainingRunsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/training-runs",
    ...options,
  });

/**
 * Submit a new training run (enqueues orchestrator submit-lora-training action)
 */
export const submitLoraTrainingRun = <ThrowOnError extends boolean = false>(
  options: Options<SubmitLoraTrainingRunData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SubmitLoraTrainingRunResponses,
    SubmitLoraTrainingRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/training-runs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a single training run with embedded checkpoints[]
 */
export const getLoraTrainingRun = <ThrowOnError extends boolean = false>(
  options: Options<GetLoraTrainingRunData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetLoraTrainingRunResponses,
    GetLoraTrainingRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/training-runs/{trainingRunId}",
    ...options,
  });

/**
 * Cancel an in-flight training run (enqueues cancel-lora-training action)
 */
export const cancelLoraTrainingRun = <ThrowOnError extends boolean = false>(
  options: Options<CancelLoraTrainingRunData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CancelLoraTrainingRunResponses,
    CancelLoraTrainingRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/training-runs/{trainingRunId}/cancel",
    ...options,
  });

/**
 * List base models available for LoRA training
 */
export const listLoraBaseModels = <ThrowOnError extends boolean = false>(
  options?: Options<ListLoraBaseModelsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListLoraBaseModelsResponses,
    ListLoraBaseModelsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/lora-base-models",
    ...options,
  });

/**
 * List LoRA kinds (subject / style / concept)
 */
export const listLoraKinds = <ThrowOnError extends boolean = false>(
  options?: Options<ListLoraKindsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListLoraKindsResponses,
    ListLoraKindsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/lora-kinds",
    ...options,
  });

/**
 * Current dataset-prep state (prep run + captions with signed URLs)
 *
 * Returns the active prep run plus each prepared caption augmented with a signed downloadUrl/thumbnailUrl, so the wizard's review grid does not need a separate assets fetch.
 */
export const getLoraDatasetPrep = <ThrowOnError extends boolean = false>(
  options: Options<GetLoraDatasetPrepData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetLoraDatasetPrepResponses,
    GetLoraDatasetPrepErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/dataset-prep",
    ...options,
  });

/**
 * Start a dataset-prep run (caption + package the reference images)
 *
 * Generates and persists the hidden trigger label, creates a prep-run row, and enqueues a `prepare-lora-dataset` job. Idempotent per LoRA via a deterministic BullMQ jobId.
 */
export const startLoraDatasetPrep = <ThrowOnError extends boolean = false>(
  options: Options<StartLoraDatasetPrepData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartLoraDatasetPrepResponses,
    StartLoraDatasetPrepErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/dataset-prep",
    ...options,
  });

/**
 * Edit the caption for one prepared dataset asset
 */
export const updateLoraDatasetCaption = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLoraDatasetCaptionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateLoraDatasetCaptionResponses,
    UpdateLoraDatasetCaptionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/loras/{loraId}/dataset-captions/{assetId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Idempotent status transition for a training run (orchestrator only)
 */
export const internalSetTrainingRunStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InternalSetTrainingRunStatusData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InternalSetTrainingRunStatusResponses,
    InternalSetTrainingRunStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/training-runs/{trainingRunId}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Record the AWS Batch job id + ARN for a training run (orchestrator only)
 */
export const internalSetTrainingRunExternalJob = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InternalSetTrainingRunExternalJobData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InternalSetTrainingRunExternalJobResponses,
    InternalSetTrainingRunExternalJobErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/training-runs/{trainingRunId}/external-job",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Register a newly-uploaded checkpoint (orchestrator only)
 */
export const internalRegisterCheckpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InternalRegisterCheckpointData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InternalRegisterCheckpointResponses,
    InternalRegisterCheckpointErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/training-runs/{trainingRunId}/checkpoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Orchestrator-facing read of a single training run (Phase 04 follow-up)
 */
export const internalGetTrainingRun = <ThrowOnError extends boolean = false>(
  options: Options<InternalGetTrainingRunData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    InternalGetTrainingRunResponses,
    InternalGetTrainingRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/training-runs/{trainingRunId}",
    ...options,
  });

/**
 * List every training run in a non-terminal status (Phase 05 follow-up)
 */
export const internalListNonTerminalTrainingRuns = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<InternalListNonTerminalTrainingRunsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    InternalListNonTerminalTrainingRunsResponses,
    InternalListNonTerminalTrainingRunsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/training-runs/non-terminal",
    ...options,
  });

/**
 * Record terminal completion of a training run (Phase 05 follow-up)
 */
export const internalFinalizeTrainingRun = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InternalFinalizeTrainingRunData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InternalFinalizeTrainingRunResponses,
    InternalFinalizeTrainingRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/training-runs/{trainingRunId}/finalize",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Orchestrator-facing read of a single LoRA by id (Phase 07 follow-up)
 */
export const internalGetLora = <ThrowOnError extends boolean = false>(
  options: Options<InternalGetLoraData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    InternalGetLoraResponses,
    InternalGetLoraErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/loras/{loraId}",
    ...options,
  });

/**
 * Orchestrator-facing read of a single checkpoint with asset.filePath denormalised (Phase 07 follow-up)
 */
export const internalGetLoraCheckpoint = <ThrowOnError extends boolean = false>(
  options: Options<InternalGetLoraCheckpointData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    InternalGetLoraCheckpointResponses,
    InternalGetLoraCheckpointErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/lora-checkpoints/{checkpointId}",
    ...options,
  });

/**
 * Revoke consent-gated support access for the ticket's project
 *
 * The customer revokes consent for one of their own tickets — closes the open consent record and withdraws the assignee's viewer grant. Idempotent.
 */
export const revokeProjectSupportAccess = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RevokeProjectSupportAccessData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RevokeProjectSupportAccessResponses,
    RevokeProjectSupportAccessErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/support/tickets/{ticketId}/access-grant",
    ...options,
  });

/**
 * Grant consent-gated support access to the ticket's project
 *
 * The customer grants consent for Studio1 Support to view the project attached to one of their own open support tickets. On success a project-scoped notification is sent back to the granting customer.
 */
export const grantProjectSupportAccess = <ThrowOnError extends boolean = false>(
  options: Options<GrantProjectSupportAccessData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GrantProjectSupportAccessResponses,
    GrantProjectSupportAccessErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/support/tickets/{ticketId}/access-grant",
    ...options,
  });

/**
 * Expire lapsed support-access grants (orchestrator sweep only)
 *
 * TTL-backstop sweep (service-token only): closes OPEN support-access grants past their expiry and withdraws the assignee's viewer grant. Called by the orchestrator loop; never exposed on a user-authorizable path.
 */
export const internalExpireLapsedSupportGrants = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<InternalExpireLapsedSupportGrantsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    InternalExpireLapsedSupportGrantsResponses,
    InternalExpireLapsedSupportGrantsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/v1/internal/support/expire-lapsed-grants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
